import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { CUSTOMER_BLOCKADE_REGISTRIES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const deleteCustomerBlockadeRegistryAction = createAsyncThunk(
    'customer/deleteCustomerBlockadeRegistryAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ CUSTOMER_BLOCKADE_REGISTRIES_PATH }/${ data.id }?liftingReason=${ data.liftingReason }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deleteCustomerBlockadeRegistrySlice = createSlice({
    name: 'deleteCustomerBlockadeRegistrySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(deleteCustomerBlockadeRegistryAction.pending, () => STATE__API__STARTED);
        builder.addCase(deleteCustomerBlockadeRegistryAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deleteCustomerBlockadeRegistryAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deleteCustomerBlockadeRegistryState = (state) => state.customer.deleteCustomerBlockadeRegistry;
export default deleteCustomerBlockadeRegistrySlice.reducer;